<template>
    <div>
        <div v-if="isSuperUser && details.message.length > 0"><b>Message</b> : {{details.message}}</div>
        <div v-if="isSuperUser"><b>Message Code</b> : {{details.message_code}}</div>
        <div v-if="isSuperUser"><b>Message Timestamp</b> : {{details.message_timestamp | moment('MM/DD/YYYY hh:mm A') }}</div>
        <div v-if="showDetails(details.extra_vars)" v-html="getDetail(details.extra_vars)"></div>
        <div><b>App Version</b> : {{details.app_version}}</div>
        <div v-if="isSuperUser && details.BC_response != null"><b>BC response</b> : {{details.BC_response}}</div>
        <div v-if="isSuperUser"><b>Internal</b> : {{details.internal}}</div>
    </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  props: ['details'],
  name: 'ba-action-detail',
  data () {
    return {}
  },
  computed: {
    ...mapState('shared', ['user']),
    isSuperUser () {
      return ((this.user !== undefined) && (this.user !== null)) ? this.user.is_superuser : false
    },
  },
  methods: {
    getDetail (data) {
      let detail = '<br><b>Details</b>'
      return this.createList(detail, data)
    },
    showDetails (data) {
      return Object.keys(data).length !== 0
    },
    titleCase (str) {
      var splitStr = str.toLowerCase().split('_')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
      }
      // Directly return the joined string
      return splitStr.join(' ')
    },
    showDetailItem (key) {
      // Only display id fields for super user
      if (key.includes('_id') && !this.isSuperUser) {
        return false
      }
      return true
    },
    createList (list, dataIn) {
      list += '<ul class="u-mt0">'
      for (var key in dataIn) {
        if (!dataIn.hasOwnProperty(key)) {
          continue
        }

        let detailData = dataIn[key]
        if (detailData === null) {
          list += '<li><b>' + this.titleCase(key) + '</b> : NULL </li>'
        } else if (detailData.constructor === Object) {
          list += this.createList('<b>' + key + '</b>', detailData)
        } else if (Array.isArray(detailData) && !typeof detailData === 'string') {
          let index = 0
          detailData.forEach(function (item) {
            list += '<li>'
            list += this.createList('<b>' + key + '[' + index +']</b>', item)
            list += '</li>'
            index++
          }.bind(this))
        } else {
          if (detailData != null) {
            if (this.showDetailItem(key)) {
              list += '<li><b>' + this.titleCase(key) + '</b> : ' + detailData + '</li>'
            }
          }
        }
      }
      list += '</ul>'

      return list
    }
  }
}

</script>
